import { Injectable } from '@angular/core';
import { RouterDataService } from '@se/se.ui.html5';
import { of, Observable, throwError } from 'rxjs';

import { ICustomPageToolbarResolver, ICustomPageToolbar } from './toolbar-data';

@Injectable()
export class RouteToolbarResolver implements ICustomPageToolbarResolver {
    constructor(private routerDataService: RouterDataService) {}

    getToolbar(): Observable<ICustomPageToolbar> {
        const data = this.routerDataService.data;

        if (!data || !data.toolbar) {
            return throwError(() => new Error('Missing custom page toolbar configuration.'));
        }

        return of(data.toolbar);
    }
}
